import GitImage from '../../img/git.svg';
import TwitterImage from '../../img/twitter.svg';
import HomeImage from '../../img/home.svg';
import PaypalImage from '../../img/paypal.svg';
import KoFiImage from '../../img/kofi.svg';

import '../../css/Footer.css';

const Footer = ({isRelative, isFixed}) => 

	<footer className={`${isRelative ? "is-relative" : "not"} ${isFixed ? "is-fixed" : "not"}`}>
		<div>
			<a href="https://teacherbuilt.me"><img src={HomeImage} alt="Home" /></a>
			<a href="https://twitter.com/D4RK_ONION"><img src={TwitterImage} alt="Twitter" /></a>
			<a href="https://gitlab.com/D4RKONION/set-cluster-finder"><img src={GitImage} alt="Gitlab" /></a>
			<a href="https://paypal.me/fullmeter"><img src={PaypalImage} alt="Paypal" /></a>
			<a href="https://ko-fi.com/fullmeter"><img src={KoFiImage} alt="KoFi" /></a>
		</div>
		{/* <em>Do you want your school edited or removed? <a href="https://forms.gle/NvxD1Zf1HDFrQu1F8">Let us know!</a> [v2.0.0]</em> */}
	</footer>

export default Footer;